import React, { FunctionComponent, SVGProps } from 'react'

export const IconSettings: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="var(--typo-brand, #0062ca)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M9.95783 3.29117C10.411 2.83796 11.0257 2.58334 11.6667 2.58334C12.3076 2.58334 12.9223 2.83796 13.3755 3.29117C13.8287 3.74438 14.0833 4.35907 14.0833 5.00001C14.0833 5.64095 13.8287 6.25564 13.3755 6.70885C12.9223 7.16206 12.3076 7.41668 11.6667 7.41668C11.0257 7.41668 10.411 7.16206 9.95783 6.70885C9.50461 6.25564 9.25 5.64095 9.25 5.00001C9.25 4.35907 9.50461 3.74438 9.95783 3.29117ZM11.6667 4.08334C11.4236 4.08334 11.1904 4.17992 11.0185 4.35183C10.8466 4.52374 10.75 4.7569 10.75 5.00001C10.75 5.24312 10.8466 5.47628 11.0185 5.64819C11.1904 5.8201 11.4236 5.91668 11.6667 5.91668C11.9098 5.91668 12.1429 5.8201 12.3148 5.64819C12.4868 5.47628 12.5833 5.24312 12.5833 5.00001C12.5833 4.7569 12.4868 4.52374 12.3148 4.35183C12.1429 4.17992 11.9098 4.08334 11.6667 4.08334Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M2.58331 5C2.58331 4.58579 2.9191 4.25 3.33331 4.25H9.99998C10.4142 4.25 10.75 4.58579 10.75 5C10.75 5.41421 10.4142 5.75 9.99998 5.75H3.33331C2.9191 5.75 2.58331 5.41421 2.58331 5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M12.5833 5C12.5833 4.58579 12.9191 4.25 13.3333 4.25H16.6666C17.0809 4.25 17.4166 4.58579 17.4166 5C17.4166 5.41421 17.0809 5.75 16.6666 5.75H13.3333C12.9191 5.75 12.5833 5.41421 12.5833 5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M4.95783 8.29117C5.41104 7.83796 6.02573 7.58334 6.66667 7.58334C7.30761 7.58334 7.92229 7.83796 8.37551 8.29117C8.82872 8.74438 9.08333 9.35907 9.08333 10C9.08333 10.641 8.82872 11.2556 8.37551 11.7089C7.92229 12.1621 7.30761 12.4167 6.66667 12.4167C6.02573 12.4167 5.41104 12.1621 4.95783 11.7089C4.50461 11.2556 4.25 10.6409 4.25 10C4.25 9.35907 4.50461 8.74438 4.95783 8.29117ZM6.66667 9.08334C6.42355 9.08334 6.19039 9.17992 6.01849 9.35183C5.84658 9.52374 5.75 9.7569 5.75 10C5.75 10.2431 5.84658 10.4763 6.01849 10.6482C6.19039 10.8201 6.42355 10.9167 6.66667 10.9167C6.90978 10.9167 7.14294 10.8201 7.31485 10.6482C7.48676 10.4763 7.58333 10.2431 7.58333 10C7.58333 9.7569 7.48676 9.52374 7.31485 9.35183C7.14294 9.17992 6.90978 9.08334 6.66667 9.08334Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M2.58331 10C2.58331 9.58579 2.9191 9.25 3.33331 9.25H4.99998C5.41419 9.25 5.74998 9.58579 5.74998 10C5.74998 10.4142 5.41419 10.75 4.99998 10.75H3.33331C2.9191 10.75 2.58331 10.4142 2.58331 10Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M7.58331 10C7.58331 9.58579 7.9191 9.25 8.33331 9.25H16.6666C17.0809 9.25 17.4166 9.58579 17.4166 10C17.4166 10.4142 17.0809 10.75 16.6666 10.75H8.33331C7.9191 10.75 7.58331 10.4142 7.58331 10Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M12.4578 13.2912C12.911 12.838 13.5257 12.5833 14.1667 12.5833C14.8076 12.5833 15.4223 12.838 15.8755 13.2912C16.3287 13.7444 16.5833 14.3591 16.5833 15C16.5833 15.641 16.3287 16.2556 15.8755 16.7089C15.4223 17.1621 14.8076 17.4167 14.1667 17.4167C13.5257 17.4167 12.911 17.1621 12.4578 16.7089C12.0046 16.2556 11.75 15.641 11.75 15C11.75 14.3591 12.0046 13.7444 12.4578 13.2912ZM14.1667 14.0833C13.9236 14.0833 13.6904 14.1799 13.5185 14.3518C13.3466 14.5237 13.25 14.7569 13.25 15C13.25 15.2431 13.3466 15.4763 13.5185 15.6482C13.6904 15.8201 13.9236 15.9167 14.1667 15.9167C14.4098 15.9167 14.6429 15.8201 14.8148 15.6482C14.9868 15.4763 15.0833 15.2431 15.0833 15C15.0833 14.7569 14.9868 14.5237 14.8148 14.3518C14.6429 14.1799 14.4098 14.0833 14.1667 14.0833Z"
      />
      <path
        fillRule="evenodd"
        stroke="none"
        clipRule="evenodd"
        d="M2.58331 15C2.58331 14.5858 2.9191 14.25 3.33331 14.25H12.5C12.9142 14.25 13.25 14.5858 13.25 15C13.25 15.4142 12.9142 15.75 12.5 15.75H3.33331C2.9191 15.75 2.58331 15.4142 2.58331 15Z"
      />
      <path
        fillRule="evenodd"
        stroke="none"
        clipRule="evenodd"
        d="M15.0833 15C15.0833 14.5858 15.4191 14.25 15.8333 14.25H16.6666C17.0809 14.25 17.4166 14.5858 17.4166 15C17.4166 15.4142 17.0809 15.75 16.6666 15.75H15.8333C15.4191 15.75 15.0833 15.4142 15.0833 15Z"
      />
    </svg>
  )
}
